import {TimeZoneVM} from '@models/serverModels';
import {getTimezonesRq} from '@store/apiEndpoints';
import {cacheForeverOptions} from '@store/queryClient';
import {queryHookFactory} from '../utils';

export const useGetTimezonesQuery = queryHookFactory<null, TimeZoneVM[]>(
  getTimezonesRq,
  {defaultQueryOptions: {...cacheForeverOptions}}
);
